export function saveSession(token, user) {
  localStorage.setItem("aerostay_token", token);
  localStorage.setItem("aerostay_user", JSON.stringify(user));
}

export function getSession() {
  try {
    const token = localStorage.getItem("aerostay_token");
    const user = JSON.parse(localStorage.getItem("aerostay_user") || "null");
    return token && user ? { token, user } : null;
  } catch {
    return null;
  }
}

export function clearSession() {
  localStorage.removeItem("aerostay_token");
  localStorage.removeItem("aerostay_user");
}
